import React, { useMemo } from "react"
import useStyles from "./styles"
import { Typography, Box } from "@material-ui/core"
import PropTypes from "prop-types"
import moment from "moment"
import SelectOrganizationHeader from "../../../Common/SelectOrganizationHeader/index"
import useActiveCompanyAdesk from "../../../../../hooks/useActiveCompanyAdesk"
import EstimateForBox from "../../../Common/HeaderByLocation/EstimateForBox/index"
import { cleanPhoneNumber } from "../../../../../utils/cleanPhoneNumber"
import parseClientCompanyAddress from "../../../../../utils/parseClientCompanyAddress"
import fixCompanyAddress from "../../../../../utils/fixCompanyAddress"
import { TextField } from "../../../../../../node_modules/@material-ui/core/index"
import { adeskPhones } from "../../../../../utils/adeskPhones"

const PreviewTableHeader = ({ type = "", soloData = {} }) => {
  const classes = useStyles()

  const id = soloData && soloData[`${type.toLowerCase()}_id`]
  const displayedSoloDate =
    soloData &&
    soloData[`${type.toLowerCase()}_shoot_date`] &&
    moment(soloData[`${type.toLowerCase()}_shoot_date`]).format("M/D/YYYY")

  const isAdesk =
    useActiveCompanyAdesk() || (soloData && soloData.company_id === 2)

  const formattedClientAddress = useMemo(
    () => {
      if (soloData && soloData.client_company_location) {
        return parseClientCompanyAddress(soloData.client_company_location)
      }
    },
    [soloData, soloData.client_company_location]
  )
  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  return (
    <Box className={classes.container}>
      <Box className={classes.leftContainer}>
        <Typography align="left" className={classes.label}>
          {type} FOR
        </Typography>
        <EstimateForBox
          data={soloData.client_name}
          label="Client Name"
          phoneLabel="Client"
        />
        <EstimateForBox
          data={soloData && cleanPhoneNumber(soloData.client_phone)}
          label="Client Phone"
          phoneLabel="Phone"
        />
        <EstimateForBox
          data={soloData && soloData.client_company_name}
          label="Client Company"
          phoneLabel="Company"
        />
        <EstimateForBox
          data={formattedClientAddress && formattedClientAddress[0]}
          label="Client Address"
          phoneLabel="Address"
        />
        <EstimateForBox
          data={formattedClientAddress && formattedClientAddress[1]}
          label=""
          phoneLabel="Address"
        />
        <Box>
          <Typography
            align="left"
            className={classes.subtitle}
            style={{ marginTop: "20px" }}
          >
            {viewportWidth > 600 ? "" : ""}
          </Typography>
          <TextField
            multiline
            value={soloData.ad_billing_note}
            disabled
            InputProps={{
              classes: {
                root: classes.textField,
              },

              disableUnderline: true,
            }}
            style={{ width: "100%" }}
          />
        </Box>
      </Box>
      <Box className={classes.middleContainer}>
        <Typography align="left" className={classes.label}>
          {type} FROM
        </Typography>
        {isAdesk ? (
          <SelectOrganizationHeader clientView headerInfo={soloData} />
        ) : (
          // if not coming from Adesk, show API data for compnay name
          <Typography align="left">{soloData.company_name}</Typography>
        )}
        {soloData &&
          soloData.company_address && (
            <Typography align="left">
              {
                fixCompanyAddress(
                  soloData.company_street,
                  soloData.company_street_number,
                  soloData.company_zip,
                  soloData.company_city,
                  soloData.company_state
                )[0]
              }
            </Typography>
          )}
        {soloData &&
          soloData.company_address && (
            <Typography align="left">
              {
                fixCompanyAddress(
                  soloData.company_street,
                  soloData.company_street_number,
                  soloData.company_zip,
                  soloData.company_city,
                  soloData.company_state
                )[1]
              }
            </Typography>
          )}
        {soloData &&
          soloData.company_phone &&
          (isAdesk ? (
            <Typography align="left" className={classes.data}>
              {cleanPhoneNumber(adeskPhones(soloData.crewmama_or_gtt))}
            </Typography>
          ) : (
            <Typography align="left" className={classes.data}>
              {cleanPhoneNumber(soloData.company_phone)}
            </Typography>
          ))}
        {soloData &&
          soloData.representative_name && (
            <Typography align="left">
              <span style={{ fontWeight: "bold" }}>Rep: </span>
              {soloData.representative_name}
            </Typography>
          )}
      </Box>
      <Box className={classes.rightContainer}>
        <EstimateForBox
          data={id}
          label={`${type[0].toUpperCase() + type.substring(1)} ID`}
          phoneLabel="ID"
        />
        {displayedSoloDate && (
          <EstimateForBox
            data={moment(displayedSoloDate).format("M/D/YYYY")}
            label={`${type[0].toUpperCase() + type.substring(1)} Shoot Date`}
            phoneLabel={`${type[0].toUpperCase() + type.substring(1)} Date`}
          />
        )}
      </Box>
    </Box>
  )
}

PreviewTableHeader.propTypes = {
  type: PropTypes.string,
  soloData: PropTypes.object,
}

export default PreviewTableHeader
